export default __webpack_public_path__ + "static/media/u3.358e20ec.jpg";